import requestStuff from './requestStuff'

const consultantSagas = [
  ...requestStuff
]

export default consultantSagas
